// Constantes de domínio da Ficha de Cadastro, compartilhadas entre a tela
// autenticada (pages/FichaCadastro.jsx) e os sub-componentes desta pasta.

export const EMAIL_HELPER_TEXT = 'Para informar mais de um e-mail, separe por ";" — exemplo: "joao@empresa.com; maria@empresa.com; pedro@empresa.com"';

export const ESTADOS_CIVIS = ["SOLTEIRO(A)", "CASADO(A)", "DIVORCIADO(A)", "VIÚVO(A)", "SEPARADO(A) JUDICIALMENTE", "UNIÃO ESTÁVEL"];
export const ESTADOS_CIVIS_SEM_CONJUGE = ["SOLTEIRO(A)", "DIVORCIADO(A)", "VIÚVO(A)", "SEPARADO(A) JUDICIALMENTE"];
export const REGIMES_CASAMENTO = ["COMUNHÃO PARCIAL DE BENS", "COMUNHÃO UNIVERSAL DE BENS", "SEPARAÇÃO TOTAL DE BENS", "PARTICIPAÇÃO FINAL NOS AQUESTOS"];
